// Inventaire des endpoints du backend EXISTANT (FastAPI + PostgreSQL
// configuré selon l'environnement), aligné sur le Document maître de continuité
// (2026-08-08). Aucune logique métier n'est dupliquée ici : le frontend ne fait
// qu'appeler ces routes. Si une donnée manque, signaler
// « Endpoint backend supplémentaire requis » — ne jamais créer un backend parallèle.
export const ENDPOINTS = {
  auth: {
    me: "/auth/me",
  },
  root: "/",
  health: "/health",
  ready: "/ready",

  dashboard: {
    resume: "/dashboard/resume", // 10 KPI
    alertes: "/dashboard/alertes", // alertes commandes + stock
    commandesOuvertes: "/dashboard/commandes-ouvertes",
  },

  clients: {
    list: "/clients",
    create: "/clients",
    detail: (clientId: string) => `/clients/${clientId}`,
    update: (clientId: string) => `/clients/${clientId}`,
    desactiver: (clientId: string) => `/clients/${clientId}/desactiver`,
    contacts: (clientId: string) => `/clients/${clientId}/contacts`,
    adresses: (clientId: string) => `/clients/${clientId}/adresses`,
    activites: (clientId: string) => `/clients/${clientId}/activites`,
    notes: (clientId: string) => `/clients/${clientId}/notes`,
  },

  produits: {
    list: "/produits",
    create: "/produits",
    detail: (produitId: string) => `/produits/${produitId}`,
    prix: (produitId: string) => `/produits/${produitId}/prix`,
    mouvements: (produitId: string) => `/produits/${produitId}/mouvements`,
  },

  catalogue: {
    resolutionProduit: "/catalogue/resolution-produit",
    resolutionDocumentaire: "/catalogue/resolution-documentaire",
  },

  commandes: {
    list: "/commandes", // filtres: statut, client_id
    create: "/commandes",
    detail: (commandeId: string) => `/commandes/${commandeId}`,
    reserver: (commandeId: string) => `/commandes/${commandeId}/reserver`,
    liberer: (commandeId: string) => `/commandes/${commandeId}/liberer`,
    creerBesoinsAchat: (commandeId: string) => `/commandes/${commandeId}/creer-besoins-achat`,
    recalculerApresReception: (commandeId: string) =>
      `/commandes/${commandeId}/recalculer-apres-reception`,
  },

  achats: {
    besoins: "/achats/besoins",
    besoinDetail: (besoinId: string) => `/achats/besoins/${besoinId}`,
    commander: (besoinId: string) => `/achats/besoins/${besoinId}/commander`,
    recevoir: (besoinId: string) => `/achats/besoins/${besoinId}/recevoir`,
    commandesFournisseur: "/achats/commandes-fournisseur",
    commandeFournisseurDetail: (commandeId: string) =>
      `/achats/commandes-fournisseur/${commandeId}`,
    recevoirLigneFournisseur: (commandeId: string, ligneId: string) =>
      `/achats/commandes-fournisseur/${commandeId}/lignes/${ligneId}/recevoir`,
  },

  preparations: {
    eligibles: "/preparations/commandes-eligibles",
    enCours: "/preparations",
    creer: (commandeId: string) => `/commandes/${commandeId}/preparations`,
    detail: (preparationId: string) => `/preparations/${preparationId}`,
    scans: (preparationId: string) => `/preparations/${preparationId}/scans`,
    finaliser: (preparationId: string) => `/preparations/${preparationId}/finaliser`,
  },

  expeditions: {
    commandesPretes: "/expeditions/commandes-pretes",
    creer: (commandeId: string) => `/commandes/${commandeId}/expeditions`,
    historique: (commandeId: string) => `/commandes/${commandeId}/expeditions`,
    detail: (expeditionId: string) => `/expeditions/${expeditionId}`,
    confirmer: (expeditionId: string) => `/expeditions/${expeditionId}/confirmer`,
  },

  livraisons: {
    preuves: "/livraisons/preuves",
    detail: (preuveId: string) => `/livraisons/preuves/${preuveId}`,
    analyser: (preuveId: string) => `/livraisons/preuves/${preuveId}/analyser`,
    associer: (preuveId: string) => `/livraisons/preuves/${preuveId}/associer`,
    valider: (preuveId: string) => `/livraisons/preuves/${preuveId}/valider`,
    refuser: (preuveId: string) => `/livraisons/preuves/${preuveId}/refuser`,
  },

  fournisseurs: "/fournisseurs",

  facturation: {
    commandesFacturables: "/facturation/commandes-facturables",
    creer: (commandeId: string) => `/commandes/${commandeId}/factures`,
    historique: (commandeId: string) => `/commandes/${commandeId}/factures`,
    detail: (factureId: string) => `/factures/${factureId}`,
    confirmer: (factureId: string) => `/factures/${factureId}/confirmer`,
    associerSage: (factureId: string) => `/factures/${factureId}/associer-sage`,
    aRegulariser: "/facturation/a-regulariser",
  },

  exceptions: {
    list: "/exceptions",
    create: "/exceptions",
    detail: (exceptionId: string) => `/exceptions/${exceptionId}`,
    prendreEnCharge: (exceptionId: string) => `/exceptions/${exceptionId}/prendre-en-charge`,
    resoudre: (exceptionId: string) => `/exceptions/${exceptionId}/resoudre`,
  },
} as const;
